import React, { useContext, useEffect, useRef, useState } from "react";
import Modal from "react-modal"; 
import { Context } from "../contexts/AppContext";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
 
import { timeStringToSeconds } from "../../lib/common";
import { postData } from "../../lib/utils";

function ChapterListModal() {
 
 const { value } = useContext(Context);

 const [appState, setAppState] = value; 
 const [modalOpen, setModalOpen] = useState(appState.modalData);
 const [isVideoPlaying,setVideoPlaying]=useState(false)
 
 const videoRef = useRef(null);

 const [hasCountedView, setHasCountedView] = useState(false);
const playTimerRef = useRef(null);

 console.log("APP STATE --- ",appState)
 useEffect(() => {
   setModalOpen(appState.modalData); // modalOpen को अपडेट करें
 }, [appState.modalData]);
  
 
  
  const [folderName, setFolderName] = useState("");
  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      position: 'fixed', // recommended over 'absolute' for full-screen modals
      top: '0',
      left:'auto',
      right: '0',
  
      width: isVideoPlaying ? '100%' : '300px',  // use width instead of maxWidth for fixed side panel
      height: '100vh', // full screen height
  
      overflow: 'auto', // allow scroll if content overflows
      border: '1px solid #00bcd4',
      backgroundColor: '#fff', // ensure visibility
      padding: isVideoPlaying ? '0px':'20px',
      zIndex: 1000, // just in case
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 999,
    },
  };
  

  const closeModal = () => {
    console.log("CLOSE MODAL11111")
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 
  }

 const playVideoHandler =(evt)=>{
  console.log(evt.currentTarget.dataset.cuepoint)
 const  cuepoint= timeStringToSeconds(evt.currentTarget.dataset.cuepoint);
 const videoElement = videoRef.current;
 console.log("VV ",videoElement.currentTime)
 videoElement.currentTime = cuepoint;
  setVideoPlaying(true)
  videoElement.play()
 }

 const handleBack=()=>{
  videoRef.current.pause();          // Pauses the video
  videoRef.current.currentTime = 0;  // Resets to beginning
  setVideoPlaying(false)
  if(appState.currentChapterArr.length<=0)
  {
    closeModal()
  }
 }
 useEffect(() => {
 
  if (appState.currentChapterArr.length <= 0) {
  
    setVideoPlaying(true);
  }
}, [appState.currentChapterArr]);


const handleVideoPlay = () => {
 
  if (!hasCountedView) {
    // Start a 3-second timer
    playTimerRef.current = setTimeout(() => {
      sendViewCount(); // API call
      setHasCountedView(true);
    }, 3000);
  }
};

const handleVideoPause = () => {
  // Agar video pause hui, timer cancel kar do
  clearTimeout(playTimerRef.current);
};

const sendViewCount = async () => {
  const videoId =appState.currentVideoId;
  if (!videoId) {
    console.error("❌ Video ID missing");
    return;
  }

 const res = await postData(`videos/updateView/${videoId}`);
 if(res)
 {
  console.log("RESPNSE.. ",res)
 }
     
  };
const handleVideoEnd = () => { 
  if(appState.modalData.isPlayAll)
  {
    playNextVideo(); // Aapka custom function
  }
 
};

const playNextVideo = () => {
  const currentIndex = appState.videoArr.findIndex(v =>
    {

       
      return (v.url === appState.currentVideoUrl);
    } )

  const nextIndex = currentIndex + 1;

  console.log("next Index ",nextIndex)

  if (nextIndex < appState.videoArr.length) {
    // next video play karo
    setAppState(prev => ({
      ...prev,
      currentVideoUrl: prev.videoArr[nextIndex].url
    }));
  } else {
    console.log("All videos finished");
  } 
};
useEffect(() => {
  if (videoRef.current) {
    videoRef.current.load();  
    videoRef.current.play();  
  }
}, [appState.currentVideoUrl]);

  return (
    <Modal
      isOpen={modalOpen.isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="New Folder Modal"
    >
      <div className="relative w-full h-full">
  {/* Video Element Always Rendered */}
  <video
  className={`w-full h-full object-contain md:object-cover ${isVideoPlaying ? 'block' : 'hidden'}`}
  crossOrigin="anonymous"
  autoPlay={appState.currentChapterArr.length <= 0}
  controls
  tabIndex={-1}
  ref={videoRef}
  onPlay={handleVideoPlay}
  onPause={handleVideoPause}
  onEnded={handleVideoEnd}
>
  <source
    src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.currentVideoUrl}`}
    type="video/mp4"
  />
  Your browser does not support the video tag.
</video>


  {/* Back Button Only When Playing */}
  {isVideoPlaying && (
    <button
      onClick={handleBack}
      className="absolute top-4 left-4 bg-black/60 text-white px-3 py-1 rounded hover:bg-black"
    >
       <FontAwesomeIcon icon={faArrowLeft} />
    </button>
  )}

  {/* Sidebar/Chapters Panel When Not Playing */} 
  {!isVideoPlaying && appState.currentChapterArr.length>0 && (
    <div className="fixed top-0 bg-yellow-800 w-full text-white sm:w-[300px] right-0 bottom-0 flex flex-col z-[99966] overflow-y-auto px-4 theme-background" style={{ willChange: "auto", transform: "none" }}>
      <div className="w-full flex items-center justify-end p-4">
        <button className="text-lg opacity-80" onClick={closeModal}>
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" className="svg-inline--fa fa-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
          </svg>
        </button>
      </div>

      <div className="w-full mb-4">
        <div className="text-xl font-medium opacity-90">Chapters</div>
      </div>

      <div className="w-full mb-4 shadow" 
       data-cuepoint={"00:00:00"}
      
       onClick={playVideoHandler}
      >
        <button className="w-full py-2 px-3 theme-button text-md font-medium flex items-center rounded opacity-90">
          <div className="mr-3">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" className="svg-inline--fa fa-play" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path fill="currentColor" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" />
            </svg>
          </div>
          <div>Play from Beginning</div>
        </button>
      </div>

      {appState.currentChapterArr.map((item, index) => (
        <div
          key={index}
          data-cuepoint={item.cuePoint}
          className="w-full mb-4 shadow"
          onClick={playVideoHandler}
        >
          <button className="w-full py-2 px-3 text-md font-medium flex items-center rounded opacity-90 theme-button-hover-link">
            <div className="mr-3 theme-link">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" className="svg-inline--fa fa-play" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path fill="currentColor" d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" />
              </svg>
            </div>
            <div>{item.title}</div>
          </button>
        </div>
      ))}
    </div>
  )}
</div>

      

  
    </Modal>
  );
}

export default ChapterListModal;
